import { Flex, Image, useBreakpointValue, Box } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ensureAuthenticated from '@/contexts/ensureAuthenticated';
// import cellImage from '@/assets/iPhone14Mockup.png';
// import granaTechWhite from '@/assets/GranaTechWhite.png';
import LoginForm2 from '@/components/LoginForm/index2';
import granaTechLogin from '@/assets/granatech-sem-texto.svg';

export default function Login2() {
  const { authenticated } = ensureAuthenticated();
  const navigate = useNavigate();

  useEffect(() => {
    if (authenticated) navigate('/');
  }, [authenticated]);

  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Flex
      minW='100vw'
      minH='100vh'
      bgGradient='linear(to-r, primary, secondary)'
      flexDirection={isMobile ? 'column' : 'row'}
      align='center'
    >

      <Flex
        w={isMobile ? '100%' : '50%'}
        h='auto' // o flushed ocupa mais de 50% da tela, se atentar a isso
        align={isMobile ? 'bottom' : 'flex-start'}
        justify={isMobile ? 'center' : 'flex-start'}
      >
        <LoginForm2 />
      </Flex>
      <Flex
        w={isMobile ? '100%' : '50%'}
        h='auto'
        align={isMobile ? 'center' : 'flex-end'}
        justify={isMobile ? 'center' : 'flex-start'}
        position={isMobile ? 'absolute' : 'static'}
        bottom={isMobile ? '10%' : 'auto'}

      >
        <Box position="relative" mx="auto" my="auto">
          {/* <Image
            src={isMobile ? granaTechWhite : cellImage}
            alt='Cell phone'
            boxSize={isMobile ? '20%' : '60%'}
            objectFit='contain'
          /> */}
         {!isMobile && ( 
            <Image
              src={granaTechLogin}
              boxSize='40%'
              position="absolute"
              top="15%"
              left="12.5%"
              objectFit='contain'
            />
          )}
        </Box>
      </Flex>
    </Flex>
  );
}